import memoize from 'lru-memoize';
import { createValidator, required } from 'utils/validation';

// @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
const validation = createValidator({
  companyName: [required],
  companyWebsite: [required],
  fullName: [required],
  email: [required],
  phone: [required],
  fullAddress: [required],
  country: [required],
  taxId: [required],
  serviceInterested: [required],
});
export default memoize(10)(validation);
